/**
 * Transcripts API
 * ================
 * API functions for transcript management
 */

import apiClient from './client';

const TRANSCRIPTS_BASE = '/api/v1/transcripts';
const LEADS_BASE = '/api/v1/leads';

/**
 * List all transcripts with pagination
 */
export const listTranscripts = async (params = {}) => {
  const response = await apiClient.get(TRANSCRIPTS_BASE, { params });
  return response.data;
};

/**
 * Get all transcripts for a specific lead
 */
export const getLeadTranscripts = async (leadId) => {
  const response = await apiClient.get(`${LEADS_BASE}/${leadId}/transcripts`);
  return response.data;
};

/**
 * Get transcript for a specific meeting
 */
export const getMeetingTranscript = async (leadId, meetingId) => {
  const response = await apiClient.get(`${LEADS_BASE}/${leadId}/meetings/${meetingId}/transcript`);
  return response.data;
};

/**
 * Update notes for a transcript
 */
export const updateTranscriptNotes = async (leadId, meetingId, notes) => {
  const response = await apiClient.patch(
    `${LEADS_BASE}/${leadId}/meetings/${meetingId}/transcript/notes`,
    { notes }
  );
  return response.data;
};

/**
 * Get transcript status for a meeting
 */
export const getTranscriptStatus = async (meetingId) => {
  const response = await apiClient.get(`${LEADS_BASE}/meetings/${meetingId}/transcript-status`);
  return response.data;
};

/**
 * Update meeting notes (stored in database and OpenSearch)
 */
export const updateMeetingNotes = async (leadId, meetingId, notes) => {
  const response = await apiClient.patch(
    `${LEADS_BASE}/${leadId}/meetings/${meetingId}/notes`,
    { notes }
  );
  return response.data;
};

const transcriptAPI = {
  listTranscripts,
  getLeadTranscripts,
  getMeetingTranscript,
  updateTranscriptNotes,
  getTranscriptStatus,
  updateMeetingNotes,
};

export default transcriptAPI;
